import { useParams, Link, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { Button } from '@/components/ui/button';
import { Clock, ArrowLeft, Loader2 } from 'lucide-react';
import posts from '@/content/blog';

export default function BlogPostPage() {
    const { slug } = useParams();
    const post = posts.find((p) => p.slug === slug);

    if (!post) {
        return <Navigate to="/blog" replace />;
    }

    const Component = post.component;

    return (
        <div className="min-h-screen bg-[#09090B] relative overflow-hidden flex flex-col">
            {/* Background patterns */}
            <div className="absolute inset-0 grid-pattern opacity-20 pointer-events-none" />
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[400px] bg-cyan-500/20 blur-[120px] rounded-full pointer-events-none" />

            {/* Navbar */}
            <nav className="relative z-10 border-b border-white/5 bg-black/20 backdrop-blur-md">
                <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-cyan-500 rounded-lg flex items-center justify-center">
                            <Clock className="w-5 h-5 text-black" />
                        </div>
                        <span className="text-lg font-bold text-white font-['Manrope']">InSynq</span>
                    </Link>
                    <div className="flex items-center gap-4">
                        <Link to="/blog">
                            <Button variant="ghost" className="text-zinc-400 hover:text-white">Blog</Button>
                        </Link>
                        <Link to="/login">
                            <Button variant="ghost" className="text-zinc-400 hover:text-white">Sign In</Button>
                        </Link>
                        <Link to="/register">
                            <Button className="bg-white text-black hover:bg-zinc-200">Get Started</Button>
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <main className="flex-1 relative z-10 max-w-3xl mx-auto w-full px-6 py-12">
                <Link to="/blog" className="inline-flex items-center text-sm text-zinc-500 hover:text-cyan-400 mb-8 transition-colors">
                    <ArrowLeft className="w-4 h-4 mr-2" /> Back to Blog
                </Link>

                <article className="prose prose-invert prose-cyan max-w-none">
                    <div className="mb-8 not-prose">
                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 font-['Manrope']">{post.meta.title}</h1>
                        <div className="flex items-center gap-4 text-sm text-zinc-500">
                            <span className="font-mono">{post.meta.date}</span>
                            <span>•</span>
                            <span>{post.meta.author}</span>
                        </div>
                    </div>

                    <Suspense fallback={<div className="flex items-center justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-cyan-500" /></div>}>
                        <Component />
                    </Suspense>
                </article>
            </main>
        </div>
    );
}
